import React from 'react';
import { Modal, ListGroup } from '../ui-kit';
import { IconExclamationTriangle } from '../ui-kit/icons';

const IncidentIconWidget = () => (
  <IconExclamationTriangle title={I18n.t('dashboards.widget_archetypes.shared.optimized_for_incidents')} />
);

const WidgetStore = props => (
  <Modal size="lg" show={true} onHide={() => props.showWidgetStore(false)}>
    <Modal.Header closeButton>
      <Modal.Title>{I18n.t('dashboards.available_widgets')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ListGroup>
        {Object.values(props.widgetArchetypes).map(archetype => (
          <ListGroup.Item
            key={archetype.id}
            onClick={() => {
              props.addWidget(archetype.id);
              props.showWidgetStore(false);
            }}
            action
          >
            <h4 className="list-group-item-heading">
              {archetype.incident_optimized && <IncidentIconWidget />} {archetype.title}
            </h4>
            <div className="list-group-item-text">{archetype.description}</div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Modal.Body>
  </Modal>
);

export default WidgetStore;
